<template>
  <div v-if="$can('view-booking', 'Yacht')">
    <v-row
      no-gutters
      justify="center"
    >
      <v-col cols="8">
        <v-row
          no-gutters
          align="center"
          justify="center"
          class="subtitle-1 pa-4"
        >
          <v-col>
            Booking Integration Settings
          </v-col>
          <v-col cols="auto">
            <v-btn
              text
              color="grey"
              rounded
              small
              class="ma-0"
              @click="modalVisible = true"
            >
              <v-icon
                left
                small
              >
                edit
              </v-icon>
              Edit
            </v-btn>
          </v-col>
        </v-row>
        <v-card elevation="10">
          <v-card-text>
            <yacht-data-row
              label="NauSys Yacht IDs"
              class="font-weight-bold"
            >
              {{ yacht.nausys_ids.join(', ') }}
            </yacht-data-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <yacht-booking-integration-settings-dialog
      :visible.sync="modalVisible"
      :yacht="yacht"
      @update:yacht="$emit('update:yacht', $event)"
    />
  </div>
</template>

<script>
import YachtDataRow from '@/components/business/yachts/details/YachtDataRow'
import YachtBookingIntegrationSettingsDialog from '@/components/business/yachts/YachtBookingIntegrationSettingsDialog'
export default {
  name: 'YachtBooking',
  components: { YachtBookingIntegrationSettingsDialog, YachtDataRow },
  props: {
    yacht: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      modalVisible: false
    }
  }
}
</script>

<style scoped>

</style>
